import React, { useState, useRef } from "react";
import styled from "styled-components";
import { useIframe } from "../hooks/useIframe";
import { useMediaQuery } from "react-responsive";

export const RegisterAgreement = ({ category, domain }) => {
  const isMobile = useMediaQuery({ maxWidth: 820 });
  const [isAgreed, setIsAgreed] = useState(false);
  const { setMoveUrl } = useIframe(domain);
  const agreementText = `1) 상기 서약자 본인 및 보호자는 대회에 참가함에 있어 경기 규칙을 준수하고 경기 중 발생할 수 있는 상해나 장비 파손, 분실 등 재산상 피해에 대하여 본인의 책임으로 처리할 것을 서약하며 본 대회에 참가를 신청합니다.\n\n2) 만 18세 미만 출전 선수는 보호자 관리하에 참가 가능합니다.\n\n3) 본인은 대회 개최중에 주최측에 의하여 경기속행에 지장이 있다고 판단될 경우 주최측의 경기중지 지시에 즉각 따르겠습니다.\n\n4) 본인은 대회 개최 중에 부상을 당하거나 사고를 당했을 경우 또는 발병하였을 경우 주최 측의 응급조치를 받는데 이의를 제기하지 않겠습니다.\n\n5) 본인은 대회 개최 중에 부상을 당하거나 사고를 당했을 경우 또는 발병하였을 경우 또한 이로 인한 후유증이 발생하였을 경우 그 원인여하를 불문하고 대회 주최 측에게 일체의 책임을 묻지 않겠습니다.\n\n6) 본인의 상속인, 근친자, 재산관리인 등이 일체의 손해배상 청구 및 법적 소송을 제기하지 않겠습니다.\n\n7) 대리참가는 절대로 시키지 않겠습니다. 또한 대리참가 사실이 발각될 경우에는 참가금지, 시상취소 등 주최 측의 어떠한 조치에도 따르겠습니다.\n\n8) 본 대회와 관련하여 영상, 사진, 기사, 기록에 대하여 매스컴 등에 대한 게재 권은 주최 측에 귀속됨을 승낙합니다.\n\n9) 주최 측에서 제정한 대회 운영규칙을 성실히 이행할 것을 다짐합니다.\n\n10) 천재지변이나 자연재해 발생 시 본 대회는 취소, 중단되며 참가비는 환불되지 않습니다.\n\n11) 참가신청서에 기재된 모든 내용은 허위로 기재한 사실이 없습니다. 본 대회를 참가함에 있어 발생하는 사고는 본인이 책임을 지며 주최 측에 책임을 돌리지 않을 것을 서약합니다.\n\n12) 대회 주최 측은 참가자의 보다 나은 서비스 제공을 위한 목적으로 협력사(참가자 상해보험사, 마라톤사진사 등)에게 최소한의 범위 내에서 참가자 정보를 제공할 수 있습니다. 하지만 그 외 다른 영리적인 목적으로 개인정보를 절대 공개하지 않습니다.\n\n13) 참가신청을 하시는 분은 대회 요강과 유의사항에 동의한 것으로 간주하오니, 참가신청을 하시기 전에 반드시 대회 요강과 유의사항을 필독하시기 바랍니다.(동의하지 않으시는 분은 참가신청을 하실 수 없습니다)\n\n14) 단체전에 참가하는 선수는 주민등록상 거주지(각 시 · 군 단위로 결성)가 6개월이 지나야  단체전에 출전할 수 있습니다. (각 시 · 군 안에서 다수팀 결성 가능)\n\n15) 단체전에 참가하는 선수는 주민등록증, 면허증, 여권을 지참하고 출발 1시간전에 필히 소집에 응해야 합니다.`;

  const toggleAgree = () => {
    setIsAgreed(!isAgreed);
  };

  const handleSubmit = () => {
    let pathName = "";
    if (category === "individual") {
      pathName = "indiv";
    } else if (category === "group") {
      pathName = "team";
    } else if (category === "club") {
      pathName = "competition";
    }

    if (isAgreed) {
      setMoveUrl(`${domain}/${pathName}?mode=apply`);
    } else {
      alert("동의 버튼을 눌러주세요.");
    }
  };

  return (
    <AgreementContainer ismobile={isMobile}>
      <VowsContainer>
        <VowsHeaderWrapper>
          <h2>참가자 유의사항 및 동의서약서</h2>
          <div>
            <HiddenCheckbox
              type="checkbox"
              id="agreeCheckbox"
              checked={isAgreed}
              onChange={toggleAgree}
            />
            {/* <CheckboxLabel htmlFor="agreeCheckbox" checked={isAgreed} /> */}
          </div>
        </VowsHeaderWrapper>
        <Divider />
        <AgreementWrapper>
          <AgreementTextarea value={agreementText} readOnly />
        </AgreementWrapper>
      </VowsContainer>
      <ButtonContainer>
        <FormButton>취소</FormButton>
        <FormButton
          id="submitButton"
          className={`formBtn ${isAgreed ? "active primary" : ""}`}
          type="submit"
          onClick={handleSubmit}
          disabled={!isAgreed}
        >
          {" "}
          신청하기 <i className="bi bi-arrow-right-circle-fill"></i>
        </FormButton>
      </ButtonContainer>
    </AgreementContainer>
  );
};

const AgreementContainer = styled.div`
  width: ${(props) => (props.ismobile ? "90%" : "82%")};
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
  margin: 0 auto;
`;

const VowsContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  border-radius: 1.5rem;
  border: 1.5px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  & h2 {
    font-family: "Jalnan", sans-serif;
  }
`;

const VowsHeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 4rem;
  box-sizing: border-box;
  word-break: keep-all;
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  /* display: none; */
  width: 3rem;
  height: 3rem;
  cursor: pointer;
`;

// const CheckboxLabel = styled.label`
//   display: inline-block;
//   width: 2.8rem;
//   height: 2.8rem;
//   border-radius: 5px;
//   border: 1.5px solid #959595;
//   position: relative;
//   cursor: pointer;
//   overflow: hidden;

//   &:after {
//     content: ${(props) => (props.checked ? ":heavy_check_mark:" : "")};
//     width: 2.8rem;
//     height: 2.8rem;
//     color: #fff;
//     background-color: #ff791a;
//     text-align: center;
//     position: absolute;
//     left: 0;
//     top: 0;
//   }
// `;

const AgreementWrapper = styled.div`
  width: 100%;
  height: 30rem;
  padding: 2rem 4rem;
  box-sizing: border-box;
`;

const AgreementTextarea = styled.textarea`
  width: 100%;
  height: 100%;
  line-height: 165%;
  letter-spacing: -0.5px;
  box-sizing: border-box;
  border: none;
  word-break: keep-all;
  font-size: 1.7rem;
  resize: none;
  outline: none;
  font-family: "Nanum Gothic", sans-serif;
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-top: 3.5rem;
`;

const FormButton = styled.button`
  width: 50%;
  padding: 2rem;
  font-size: 1.9rem;
  font-weight: 700;
  background: #fff;
  border-radius: 100px 100px 100px 0px;
  border: 1.5px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;

  &.primary {
    border: 1.5px solid #ff791a;
    background: #ff791a;
    color: white;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
`;
